import type { PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'
import type { AdminClient } from './adminClient'

const AdminClientContext = createContext<AdminClient | null>(null)

/** Makes the admin oRPC client available to screens that call procedures directly. */
export function AdminClientProvider({
  client,
  children,
}: PropsWithChildren<{ client: AdminClient }>) {
  return <AdminClientContext value={client}>{children}</AdminClientContext>
}

export function useAdminClient(): AdminClient {
  const client = useContext(AdminClientContext)
  if (client === null) {
    throw new Error('useAdminClient() outside <AdminClientProvider>')
  }
  return client
}
